export const WELLSTAT_IAQ_INDEX_NAME = "WellStat IAQ";
